<div class="container">
  <section class="hero mb-lg">
    <span class="hero-eyebrow">Contact Us</span>
    <h1>Get in Touch</h1>
    <p>
      Questions about a calculator, one of our premium services, or spotted something that looks
      off? Send us a message and we'll get back to you by email. We usually reply within
      1–2 working days.
    </p>

    <ul class="trust-strip">
      <li>Built for India</li>
      <li>Your details are never shared</li>
      <li>Spam-protected — humans only</li>
    </ul>

    <div class="direct-contact">
      <a class="direct-contact-link direct-contact-link--call" href="tel:+919535300245">
        <mat-icon>call</mat-icon> Call +91 95353 00245
      </a>
      <a class="direct-contact-link direct-contact-link--whatsapp" href="https://wa.me/919535300245" target="_blank" rel="noopener">
        <svg class="direct-contact-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.9 9.9 0 0 0 4.74 1.21h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.85 9.85 0 0 0 12.04 2zm5.8 14.14c-.24.68-1.4 1.3-1.93 1.35-.5.05-1.13.07-1.82-.11-.42-.11-.96-.31-1.65-.6-2.9-1.25-4.79-4.17-4.94-4.36-.14-.2-1.18-1.57-1.18-3 0-1.42.75-2.12 1.02-2.41.26-.28.58-.35.77-.35.2 0 .39 0 .56.01.18.01.42-.07.65.5.24.58.82 2 .89 2.14.07.14.12.31.02.5-.09.2-.14.31-.28.48-.14.16-.29.36-.42.49-.14.13-.28.28-.12.55.16.28.7 1.16 1.51 1.88 1.04.93 1.91 1.22 2.19 1.36.28.14.44.12.6-.07.16-.19.68-.79.87-1.06.18-.28.37-.23.63-.14.26.09 1.65.78 1.93.92.28.14.47.21.54.33.07.13.07.71-.17 1.39z"/>
        </svg>
        WhatsApp Us
      </a>
    </div>
  </section>

  @if (submitted()) {
    <section class="card success-card mb-lg">
      <div class="success-icon" aria-hidden="true"></div>
      <h2 class="section-title">Message sent</h2>
      <p>
        Thanks for reaching out — we've received your message and will reply to the email address
        you gave us. Meanwhile, feel free to keep exploring our
        <a routerLink="/">free calculators</a>.
      </p>
    </section>
  } @else {
    <section class="card mb-lg">
      <h2 class="section-title">Send us a message</h2>

      <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
        <div class="field-row-2">
          <div class="field-group" [class.has-error]="hasError('name')">
            <label class="field-label" for="contact-name">Your Name</label>
            <div class="input-shell">
              <input id="contact-name" type="text" formControlName="name"
                placeholder="e.g. Rajesh" autocomplete="name" maxlength="120" />
            </div>
            @if (hasError('name')) {
              <div class="field-error">Please enter your name.</div>
            }
          </div>

          <div class="field-group" [class.has-error]="hasError('email')">
            <label class="field-label" for="contact-email">Email</label>
            <div class="input-shell">
              <input id="contact-email" type="email" formControlName="email"
                placeholder="e.g. rajesh@example.com" autocomplete="email" maxlength="254" />
            </div>
            @if (hasError('email')) {
              <div class="field-error">Please enter a valid email address.</div>
            }
          </div>
        </div>

        <div class="field-group" [class.has-error]="hasError('subject')">
          <label class="field-label" for="contact-subject">Subject</label>
          <div class="input-shell">
            <input id="contact-subject" type="text" formControlName="subject"
              placeholder="e.g. Question about Reminders" maxlength="200" />
          </div>
          @if (hasError('subject')) {
            <div class="field-error">Please add a subject.</div>
          }
        </div>

        <div class="field-group" [class.has-error]="hasError('message')">
          <label class="field-label" for="contact-message">Message</label>
          <textarea id="contact-message" class="contact-textarea" formControlName="message"
            rows="6" placeholder="How can we help?" maxlength="5000"></textarea>
          @if (hasError('message')) {
            <div class="field-error">Please enter your message.</div>
          }
        </div>

        <!-- Cloudflare Turnstile: proves the sender is human before we accept the form. -->
        <div class="captcha-row">
          <div id="contact-turnstile"></div>
          @if (!captchaReady()) {
            <p class="captcha-hint">Loading the human-verification check…</p>
          }
        </div>

        @if (errorMessage()) {
          <div class="form-error-hint">{{ errorMessage() }}</div>
        }

        <button type="submit" class="btn btn-primary contact-submit"
          [disabled]="submitting()">
          @if (submitting()) {
            <span class="spinner"></span> Sending…
          } @else {
            Send message
          }
        </button>
      </form>
    </section>
  }
</div>
